import { createFileRoute } from '@tanstack/react-router';
import { setActiveOrgId } from '@/api/axios-instance';
import { ChooseSalonPage } from '@/features/salon-picker/choose-salon-page';

// Static segment: wins over `/$orgId`. Signed-out visitors are sent to /login by `_auth`.
export const Route = createFileRoute('/_auth/choose-salon')({
  beforeLoad: ({ preload }) => {
    // No salon is open while picking one (a hover preload is not a visit: keep the open salon).
    if (!preload) setActiveOrgId(null);
  },
  component: ChooseSalonPage,
});
